import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { CheckCircle2, Tag } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-14 pb-10 md:pt-32 md:pb-24 px-4 sm:px-6 lg:px-8 bg-[#FAF7F2] overflow-hidden" data-id="element-53">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-[#F0F4EE] -z-10 skew-x-12 translate-x-20 opacity-50" data-id="element-54" />

      <div className="max-w-5xl mx-auto" data-id="element-55">
        {/* Mobile-first: image on top */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7
      }} className="flex justify-center mb-8 md:hidden" data-id="element-56">
          <img src="https://cdn.magicpatterns.com/uploads/r6zdbWzKrqLQ23SEnXG5aV/mokup_smoothies1.png" alt="Barriga Desinflamada - Plan de 14 días de smoothies anti-hinchazón" className="w-full max-w-xs rounded-2xl shadow-2xl" data-id="element-57" />
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-58">
          {/* Left: Copy */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-center md:text-left" data-id="element-59">
            <div className="flex items-center justify-center md:justify-start gap-3 mb-6" data-id="element-60">
              <span className="inline-block px-4 py-1 text-sm font-semibold tracking-wider text-[#5B7C5B] uppercase bg-[#F0F4EE] rounded-full" data-id="element-61">
                Plan de 14 Días
              </span>
              <span className="inline-flex items-center gap-1 px-3 py-1 text-sm font-bold text-white bg-[#D4836B] rounded-full" data-id="element-62">
                <Tag className="h-3.5 w-3.5" data-id="element-63" />
                -36% dto.
              </span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold text-[#2D2A26] leading-tight mb-4 md:mb-6" data-id="element-64">
              Barriga menos hinchada en 14 días{' '}
              <span className="italic text-[#5B7C5B]" data-id="element-65">
                (sin otra dieta imposible)
              </span>
            </h1>

            <p className="text-base md:text-xl text-[#6B6560] mb-6 md:mb-8 leading-relaxed" data-id="element-66">
              Plan práctico de smoothies anti-hinchazón para mujeres 35–45 que
              ya lo han probado todo: recetas con cantidades, calendario, listas
              de compra y ajustes por tolerancia.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-3 md:gap-4 mb-4 md:mb-6" data-id="element-67">
              <Button className="w-full sm:w-auto" onClick={() => document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-68">
                <span className="flex items-center gap-2" data-id="element-69">
                  Comprar y descargar
                  <span className="line-through opacity-60 text-base" data-id="element-70">
                    US$9.99
                  </span>
                  <span className="font-bold text-lg" data-id="element-71">US$6.39</span>
                </span>
              </Button>
            </div>

            <div className="flex items-center justify-center md:justify-start gap-2 text-sm text-[#5B7C5B] font-medium" data-id="element-72">
              <CheckCircle2 className="h-4 w-4" data-id="element-73" />
              <p data-id="element-74">
                Sin promesas de kilos. Con estructura simple que funciona en
                días reales.
              </p>
            </div>
          </motion.div>

          {/* Right: Product mockup (desktop only) */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} className="hidden md:flex justify-center" data-id="element-75">
            <img src="https://cdn.magicpatterns.com/uploads/r6zdbWzKrqLQ23SEnXG5aV/mokup_smoothies1.png" alt="Barriga Desinflamada - Plan de 14 días de smoothies anti-hinchazón" className="w-full max-w-md rounded-2xl shadow-2xl" data-id="element-76" />
          </motion.div>
        </div>
      </div>
    </section>;
}